'use client'

import { AnimatePresence, motion } from 'motion/react'

type ILoadingSpinnerProps = { color: string; size: number }

export const LoadingSpinner = (props: ILoadingSpinnerProps) => {
    return (
        <AnimatePresence>
            <motion.div
                initial={{ rotate: 0 }}
                animate={{
                    rotate: 360,
                }}
                transition={{ duration: 0.7, repeat: Infinity, ease: 'linear' }}
                className="flex justify-center items-center"
            >
                <span
                    style={{
                        height: `${props.size}px`,
                        width: `${props.size}px`,
                    }}
                    className="block"
                >
                    <motion.span
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.2, ease: 'easeOut' }}
                    >
                        <svg
                            strokeDasharray={150}
                            strokeWidth="6px"
                            strokeDashoffset={0}
                            viewBox="0 0 100 100"
                        >
                            <circle
                                cx="50"
                                cy="50"
                                r="32"
                                stroke={props.color || 'white'}
                                fill="transparent"
                            />
                        </svg>
                    </motion.span>
                </span>
            </motion.div>
        </AnimatePresence>
    )
}
